module.exports = __webpack_public_path__ + "img/nine.75358310.png";